import React, { FC, useContext, useMemo } from 'react';
import classNames from 'classnames';
import ReorderResizeTable from 'components/ReorderResizeTable';

import {
  COLUMNS,
  CUSTOM_COL_SIZES,
  HEADING_TRANSLATIONS,
  SORTING_VALUES,
  ActivityMetricsTableData,
  BODY_CONTENT_GENERATE,
} from './data';
import { useLocation, useNavigate } from 'react-router-dom';
import { getSellingPortfolio } from 'utils';
import AuthContext from 'providers/Auth/Auth.context';

import './ActivityMetricsTable.styles.scss';
import './ActivityMetricsTable.styles.responsive.scss';

type ActivityMetricsTableProps = {
  className?: string;
  isLoading?: boolean;
  isDragDisabled?: boolean;
  totalPages?: number;
  data: ActivityMetricsTableData[];
};

const ActivityMetricsTable: FC<ActivityMetricsTableProps> = (props) => {
  const {
    className,
    isLoading,
    isDragDisabled = true,
    totalPages = 1,
    data,
  } = props;

  const { updateLatestActivityMetricsLocation } = useContext(AuthContext);

  const location = useLocation();

  const classes = classNames('activity-metrics-table', className);

  const tableContentTransformations = useMemo(
    () =>
      COLUMNS.reduce(
        (acc, col) => ({
          ...acc,
          [col]: (data: ActivityMetricsTableData) =>
            BODY_CONTENT_GENERATE[col]({
              data,
            }),
        }),
        {},
      ),
    [],
  );

  const navigate = useNavigate();

  return (
    <ReorderResizeTable
      className={classes}
      isDragDisabled={isDragDisabled}
      totalPages={totalPages}
      data={data}
      columns={COLUMNS}
      headingTranslations={HEADING_TRANSLATIONS}
      sortingValues={SORTING_VALUES}
      isDataLoading={isLoading}
      tableContentTransformations={tableContentTransformations}
      customSizes={CUSTOM_COL_SIZES}
      onRowClick={({ dealId }) => {
        updateLatestActivityMetricsLocation(location);
        navigate(getSellingPortfolio(dealId, 'deal'));
      }}
    />
  );
};

export default ActivityMetricsTable;
